import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit, SimpleChanges, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { HoleCondition } from 'src/app/bo/geology/holeCondition';
import { ProprieteAffichee } from 'src/app/bo/proprieteAffichee';
import { FonctionsService } from 'src/app/services/fonctions-partagees.service';
import { HttpService } from 'src/app/services/http.service';
import { UtilisateurService } from 'src/app/services/utilisateur.service';

@Component({
  selector: 'app-hole-condition-gui',
  templateUrl: './hole-condition-gui.component.html',
  styleUrls: ['./hole-condition-gui.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule]
})
export class HoleConditionGuiComponent implements OnInit {
  @Input() currentRegionId:number = undefined;
  @Input() isAdminOrResReg = false;


  table_width:number[] = [8,39,39,6,6];

  showErrorModif = false;
  showErrorNew = false;

  tabHoleConditions = signal<HoleCondition[]>([]);
  selectedHoleCondition: HoleCondition = new HoleCondition();
  oldHoleCondition: HoleCondition = new HoleCondition();

  newHoleCondition: HoleCondition = new HoleCondition();
  proprietesAffichees: ProprieteAffichee[] = [];

  isModifiable = -1;
  lastToucheIndex = -1;
  isFooterFocus:boolean;



  constructor(
     private readonly http: HttpService,
     public utilService: UtilisateurService,
     private readonly fonctionsService: FonctionsService
     ) {
       this.proprietesAffichees = new HoleCondition().getProprietesAffichees();
    }
  

  ngOnInit(): void {
    this.getHoleConditionByRegionId();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['currentRegionId']){
      this.getHoleConditionByRegionId();
    }
  }

  protected selectHoleCondition(holeCondition: HoleCondition, index:number, e:any){
    if(this.selectedHoleCondition.id === holeCondition.id) return;

    if(this.lastToucheIndex > -1 && this.oldHoleCondition.id > 0 ){
      const restored = this.oldHoleCondition;
      const restoreIndex = this.lastToucheIndex;
      this.tabHoleConditions.update(arr => arr.map((item, i) => i === restoreIndex ? restored : item));
    }

    this.lastToucheIndex = index;
    this.oldHoleCondition = Object.assign({}, holeCondition);

    this.selectedHoleCondition = Object.assign({}, holeCondition)
    this.isModifiable = index;
    this.clearNew();
  }

  protected clearNew(){
    this.newHoleCondition = new HoleCondition();
    this.isFooterFocus = false;

  }
  protected clearSelected(){
    this.selectedHoleCondition = new HoleCondition();
  }

  protected newHoleConditionChange(){
    this.selectedHoleCondition = new HoleCondition();
    this.isModifiable = -1;
    this.isFooterFocus = true;
  }

  protected onFocusOutEvent(){
    this.isFooterFocus = false;
  }

  private getHoleConditionByRegionId(){
    if (this.currentRegionId == undefined){
      this.currentRegionId = this.utilService.currentRegionForSetupRegion.regionId;
    }
    this.fonctionsService.loading_screen(true);

    const url = "Geology/GetAllHoleConditionsByRegionId/" + this.currentRegionId;

    this.http.get<HoleCondition[]>(url).subscribe({
     next: result =>{
      this.tabHoleConditions.set(result);
    } ,
    error: (error: HttpErrorResponse) => {
      if(error.status === 401 || error.status === 403){
    console.log(error.error);
      }
      this.fonctionsService.launch_toast(false);
      this.fonctionsService.loading_screen(false);
    },
    complete:() => {
       this.fonctionsService.loading_screen(false);
     }
   })
  }

  protected createHoleCondition(){
    if(this.newHoleCondition.description === '' || this.newHoleCondition.shortName === ''){
        this.showErrorNew = true;
        setTimeout(() => {
        this.showErrorNew = false;
      }, 1500);
      return;
    }

    this.fonctionsService.loading_screen(true);
    this.newHoleCondition.regionId = this.currentRegionId;
    const url = "Geology/CreateHoleCondition";
    this.http.post(url, this.newHoleCondition).subscribe({
     next: result =>{
      this.clearNew();
      this.clearSelected();
      this.getHoleConditionByRegionId();
      this.fonctionsService.launch_toast(true);
      this.fonctionsService.loading_screen(false);
     } ,
     error: (error: HttpErrorResponse) => {
      if(error.status === 401 || error.status === 403){
    console.log(error.error);
      }
      this.fonctionsService.launch_toast(false);
      this.fonctionsService.loading_screen(false);
     },
     complete:() => {
      this.fonctionsService.loading_screen(false);
     }
   })
  }

  protected update(h:HoleCondition, index:number){
    if(h.description === '' || h.shortName === ''){
      this.showErrorModif = true;
      setTimeout(() => {
      this.showErrorModif = false;
    }, 1500);
    return;
  }

      this.updateApi(this.tabHoleConditions()[index]).subscribe({
        next: result =>{
          this.clearNew();
          this.clearSelected();
          this.oldHoleCondition = new HoleCondition();
          this.lastToucheIndex = -1;
          this.isModifiable = -1;
          this.fonctionsService.loading_screen(false);
          this.fonctionsService.launch_toast(true);
        } ,
        error: (error: HttpErrorResponse) => {
          if(error.status === 401 || error.status === 403){
        console.log(error.error);
          }
          this.fonctionsService.launch_toast(false);
          this.fonctionsService.loading_screen(false);
        },
        complete:() => {
          this.fonctionsService.loading_screen(false);
        }
      })
  }

  protected delete(selectedDrillog:HoleCondition){
    selectedDrillog.regionId = 0;
      this.updateApi(selectedDrillog).subscribe({
        next: result =>{
         this.clearNew();
         this.clearSelected();
         this.oldHoleCondition = new HoleCondition();
         this.lastToucheIndex = -1;
         this.isModifiable = -1;
         this.fonctionsService.loading_screen(false);
         this.tabHoleConditions.update(arr => arr.filter((item) => item.id !== selectedDrillog.id));
         this.fonctionsService.launch_toast(true);
        } ,
        error: (error: HttpErrorResponse) => {
         if(error.status === 401 || error.status === 403){
       console.log(error.error);
         }
         this.fonctionsService.launch_toast(false);
         this.fonctionsService.loading_screen(false);
        },
        complete:() => {
         this.fonctionsService.loading_screen(false);
        }
      })
  }

  private updateApi(selectedHoleCondition:HoleCondition){
    this.fonctionsService.loading_screen(true);
    const url = "Geology/UpdateHoleCondition";
    return this.http.put(url, selectedHoleCondition)
  }


}
